import React from "react";

const ContactInfoSectionEN = () => {
  return (
    <section id="contact-info" className="section-padding bg-gradient-to-br from-[#FAF9F6] to-[#EDE6DB]/30">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="font-serif text-4xl sm:text-5xl font-bold text-[#1C3A27] mb-6">
            Contact us
          </h2>
          <p className="text-xl text-[#1C3A27]/70 max-w-3xl mx-auto">
            We are at your disposal to answer all your questions
          </p>
        </div>
        {/* Contact info content coming soon */}
      </div>
    </section>
  );
};

export default ContactInfoSectionEN;